var map = {
	"./Anu.jpg": "e3d0",
	"./Assistant.jpg": "3abf",
	"./Bishop.jpg": "7ca4",
	"./Clerk.jpg": "ff5d",
	"./Lukose Antony.jpeg": "63db",
	"./PTM.jpg": "dbf1",
	"./Principal.jpeg": "ffd8",
	"./Rajesh.jpg": "e4b8",
	"./Selvy.jpg": "68b3",
	"./christamma.jpg": "69e9",
	"./co.jpg": "7d45",
	"./dennies-kannamalil.jpeg": "5cbe",
	"./liza-vincent.jpeg": "e99a",
	"./newPrincipal.jpeg": "5018",
	"./tom.jpg": "4629"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2174";